import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="h-[58vh] flex flex-col items-center justify-center bg-white text-center px-4">
      <h1 className="text-7xl font-bold text-gray-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">
        Page Not Found
      </h2>
      
       <p className="text-gray-500 mb-6">
       Sorry! This page does not exist. 
      </p>

      <Link
        to="/"
        className="bg-gray-600 text-white px-6 py-2 rounded-lg hover:bg-gray-700 transition"
      >
        Go to Home Page
      </Link>
    </div>
  );
}
